const OA_ROUTE = [
  {
    path: 'oa/article-list',
    name: 'OaArticleList',
    component: () => import('@/views/oa-management/article/index.vue'),
    meta: {
      title: 'OA文章管理',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'oa/article-edit',
    name: 'OaArticleEdit',
    component: () => import('@/views/oa-management/article/edit.vue'),
    meta: {
      title: 'OA文章编辑',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'oa/company-system',
    name: 'OaCompanySystem',
    component: () => import('@/views/oa-management/company-system'),
    meta: {
      title: '公司制度管理',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'oa/banner',
    name: 'OaBanner',
    component: () => import('@/views/oa-management/banner'),
    meta: {
      title: 'banner管理',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'oa/outstanding-employee',
    name: 'OaOutSandingEmployee',
    component: () => import('@/views/oa-management/outstanding-employee'),
    meta: {
      title: '优秀员工管理',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'oa/dev-progress',
    name: 'OaDevProgress',
    component: () => import('@/views/oa-management/dev-progress/index.vue'),
    meta: {
      title: 'OA项目管理',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'oa/dev-progress-detail',
    name: 'OaDevProgressDetail',
    component: () => import('@/views/oa-management/dev-progress/detail.vue'),
    meta: {
      title: 'OA项目详情',
      icon: '',
      keepAlive: false,
    },
  },
  {
    path: 'oa/dev-bug-list',
    name: 'OaDevBugList',
    component: () => import('@/views/oa-management/dev-bug/index.vue'),
    meta: {
      title: 'BUG列表',
      icon: '',
      keepAlive: true,
    },
  },
  {
    path: 'oa/dev-bug-detail',
    name: 'OaDevBugDetail',
    component: () => import('@/views/oa-management/dev-bug/detail.vue'),
    meta: {
      title: 'BUG 详情',
      icon: '',
      keepAlive: false,
    },
  },
  {
    path: '/oa-progress-page',
    name: 'oa-progress-page',
    component: () => import('@/views/oa-management/dev-progress/progress.vue'),
    meta: { title: '项目列表', icon: 'home-4-line', keepAlive: true },
  },
]
export default OA_ROUTE
